var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87805 11.5366H1V30.7561H29V11.5366H19.6341",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4394 22.7803C14.8299 23.1708 15.4631 23.1708 15.8536 22.7803L22.2176 16.4163C22.6081 16.0258 22.6081 15.3926 22.2176 15.0021C21.827 14.6116 21.1939 14.6116 20.8033 15.0021L15.1465 20.659L9.48963 15.0021C9.09911 14.6116 8.46594 14.6116 8.07542 15.0021C7.68489 15.3926 7.68489 16.0258 8.07542 16.4163L14.4394 22.7803ZM16.1465 1.00001C16.1465 0.447725 15.6988 9.56088e-06 15.1465 9.53674e-06C14.5942 9.5126e-06 14.1465 0.447725 14.1465 1.00001L16.1465 1.00001ZM16.1465 22.0732L16.1465 1.00001L14.1465 1.00001L14.1465 22.0732L16.1465 22.0732Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.f296e0a2e72d6f280072272f3fd42a08.svg";
export { ForwardRef as ReactComponent };